import { styled, Box } from "@mui/material";

export const IntervalAndSpecificDaysContainer = styled(Box)(() => ({

                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "1rem",
                                            marginTop: "1rem",
}))